import { useState, useEffect } from "react";
import { ReactTableDataGrid } from "components/Table";

const limit = 10;
const TableUserFulfill = ({ data }) => {
    const [list, setList] = useState([]);

    useEffect(() => {
        if (data) {
            setList(data?.slice(0, limit));
        }
    }, [data]);

    const columns = [
        {
            field: "_id",
            width: 40,
            cellClass: "centered-cell",
            headerName: "",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
            sortable: false,
        },
        {
            field: "email",
            headerName: "Printer",
            cellClass: "centered-cell",
            sortable: false,
            flex: 1,
        },
        {
            field: "totalShop",
            headerName: "Total Shop",
            cellClass: "centered-cell",
            sortable: false,
            // flex: 1,
            // cellRenderer: ({ rowIndex, value: cell, data: row }) => (row?.typePOD?.totalOrder || 0) + (row?.typeDROP?.totalOrder || 0),
        },
        {
            field: "-",
            headerName: "Total Order",
            cellClass: "centered-cell",
            sortable: false,
            // flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (row?.typePOD?.totalOrder || 0) + (row?.typeDROP?.totalOrder || 0),
        },
        {
            field: "typePOD",
            headerName: "POD Order",
            cellClass: "centered-cell",
            sortable: false,
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <div>
                    <div>Total: {cell?.totalOrder || 0}</div>
                    <div>Base Cost: {cell?.totalBaseCostOrder.toFixed(2) || 0} / Real: {cell?.totalBaseCostFulfill.toFixed(2) || 0}</div>
                </div>
            ),
        },
        {
            field: "typeDROP",
            headerName: "DROP Order",
            cellClass: "centered-cell",
            sortable: false,
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <div>
                    <div>Total: {cell?.totalOrder || 0}</div>
                    <div>Base Cost: {cell?.totalBaseCostOrder.toFixed(2) || 0} / Real: {cell?.totalBaseCostFulfill.toFixed(2) || 0}</div>
                </div>
            ),
        },
        {
            field: "avgOrderPerShop",
            headerName: "AVG Order/Shop",
            cellClass: "centered-cell",
            sortable: false,
            flex: 1,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (((row?.typePOD?.totalOrder || 0) + (row?.typeDROP?.totalOrder || 0)) / (row?.totalShop || 1)).toFixed(2) || 0,
        },
    ];

    const onTableChanged = ({ page }) => {
        const startIndex = (page - 1) * limit;
        setList(data.slice(startIndex, startIndex + limit));
    };

    return (
        <ReactTableDataGrid
            idProperty="_id"
            tableName={"analyticAdminUserFulfill"}
            columns={columns}
            height={600}
            rowData={list}
            gridOptions={{
                rowHeight: 80,
                reactiveCustomComponents: true,
            }}
            paginationPageSize={limit}
            totalSize={data?.length || 0}
            emptyText={"No data!"}
            rowSelection="multiple"
            onTableChanged={onTableChanged}
            isSearchText={false}
        />
    );
};

export default TableUserFulfill;
